<div *ngIf="activities?.length > 0" class="listing-content-section">
  <h3>
    Site Exclusive Activities
    <span class="fine-print trinidad">(Offered on site)</span>
  </h3>
  <div class="w-layout-grid listing-icon-grid">
    <div *ngFor="let activity of activities; let i = index" class="icon-wrapper">
      <div
        (click)="toggleDescription(i)"
        class="icon-inner-wrapper"
        [ngClass]="{ 'with-dropdown': activity.description }"
      >
        <div class="title-wrapper">
          <div class="icon-bullet">
            <div class="w-embed">
              <curbnturf-site-svgs [type]="activity.type"> </curbnturf-site-svgs>
            </div>
          </div>
          <div class="rift-soft-copy">{{ name(activity) }}</div>
        </div>
        <div *ngIf="activity.description && !openDescriptions[i]" class="dropdown-icon">
          <div class="html-embed expanded w-embed">
            <curbnturf-misc-svg icon="dropdown"></curbnturf-misc-svg>
          </div>
        </div>

        <div *ngIf="openDescriptions[i]" class="dropdown-icon">
          <div class="w-embed">
            <curbnturf-misc-svg icon="dropdown"></curbnturf-misc-svg>
          </div>
        </div>
      </div>
      <div *ngIf="openDescriptions[i]" class="fine-print offsite">
        {{ activity.description }}
      </div>
    </div>
  </div>
</div>
